"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasGermanTipSuggestion = exports.hasUnitedStatesTipSuggestion = exports.hasCanadianTipSuggestion = exports.DEFAULT_TIP_PERCENTAGE_FOR_SMALL_AMOUNTS_BY_ORGANIZATION_COUNTRY = void 0;
const enums_1 = require("../../enums");
const country_1 = require("../enums/country");
exports.DEFAULT_TIP_PERCENTAGE_FOR_SMALL_AMOUNTS_BY_ORGANIZATION_COUNTRY = {
    [country_1.OrganizationCountry.Canada]: 15,
    [country_1.OrganizationCountry.UnitedStates]: 17,
    [country_1.OrganizationCountry.GreatBritain]: 15,
    [country_1.OrganizationCountry.Australia]: 15,
    [country_1.OrganizationCountry.NewZealand]: 15,
    [country_1.OrganizationCountry.Ireland]: 15,
    [country_1.OrganizationCountry.Germany]: 15,
};
const hasCanadianTipSuggestion = (organizationCountry) => {
    return organizationCountry === country_1.OrganizationCountry.Canada || organizationCountry === country_1.OrganizationCountry.Australia;
};
exports.hasCanadianTipSuggestion = hasCanadianTipSuggestion;
const hasUnitedStatesTipSuggestion = (organizationCountry) => {
    return organizationCountry === country_1.OrganizationCountry.UnitedStates;
};
exports.hasUnitedStatesTipSuggestion = hasUnitedStatesTipSuggestion;
const hasGermanTipSuggestion = (organizationCountry, formCategory) => {
    return organizationCountry === country_1.OrganizationCountry.Germany && formCategory !== enums_1.TicketingFormCategory.Auction;
};
exports.hasGermanTipSuggestion = hasGermanTipSuggestion;
